import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M10 4.343c-.207 0-.41-.049-.596-.141L6.596 2.798A1.333 1.333 0 0 0 6 2.658m4 1.685c.207 0 .41-.049.596-.141l2.44-1.22a.667.667 0 0 1 .964.597v8.509a.667.667 0 0 1-.369.595l-3.034 1.518c-.185.092-.39.14-.596.14m0-10v10m0 0c-.207 0-.41-.048-.596-.14l-2.808-1.404a1.333 1.333 0 0 0-1.192-.001l-2.44 1.219a.667.667 0 0 1-.964-.6V4.913a.667.667 0 0 1 .369-.596l3.034-1.518c.185-.093.39-.14.596-.14m0 0v10"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "clinic-view-map"}) } }